/**
 * @file 案件担当可否変更
 */
'use strict'

/**
 * @classname ChangeManagerFlag
 * @classdesc 案件担当可否変更
 */
export default class ChangeManagerFlag {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('[name="manager_flag"]')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$target = $('#form-wrap')
		this._$e.on('click', () => this.onClick())
		this.onClick()
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeManagerFlag
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`)
		const value = $('[name="manager_flag"]:checked').val()
		if (value === '1') {
			this._$target.show().find('.form_url').addClass('validate').removeClass('ignore-validate')
		} else {
			this._$target.hide().find('.form_url').val('').removeClass('validate').addClass('ignore-validate').removeClass('is-invalid')
			this._$target.find('.error-tip').removeClass('show').find('.error-tip-inner').html('')
		}
	}
}
